import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { type LibraryBook, topAuthors } from '@/lib/insights'
import { InsightCard, InsightEmpty } from './InsightCard'

/** Authors with the most books in the library */
export function TopAuthorsCard({ books }: { books: LibraryBook[] }) {
  const { t } = useTranslation()
  const authors = useMemo(() => topAuthors(books, 5), [books])

  return (
    <InsightCard
      icon="✍️"
      title={t('insights.topAuthors.title')}
      description={t('insights.topAuthors.description')}
    >
      {authors.length === 0 ? (
        <InsightEmpty>{t('insights.noBooksYet')}</InsightEmpty>
      ) : (
        <ol className="space-y-2">
          {authors.map((a, i) => (
            <li key={a.author} className="flex items-center gap-3 text-sm">
              <span className="w-4 shrink-0 text-right font-medium text-muted-foreground">
                {i + 1}
              </span>
              <span className="min-w-0 flex-1 truncate font-medium text-foreground">
                {a.author}
              </span>
              <span className="shrink-0 text-xs text-muted-foreground">
                {t('insights.topAuthors.readOfTotal', { read: a.read, total: a.total })}
                {a.averageRating !== null && ` · ${a.averageRating}⭐`}
              </span>
            </li>
          ))}
        </ol>
      )}
    </InsightCard>
  )
}
